import { isEmpty } from 'lodash';
import linkifyHtml from 'linkifyjs/html';

export default {
  methods: {
    parseHyperlink(content) {
      if (isEmpty(content)) {
        return null;
      }

      return linkifyHtml(content);
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/parses.js